import React from 'react';
import type { ColDef, GridOptions, GridReadyEvent } from 'ag-grid-community';

import Grid from '../../Grid/Grid';
import IncompatibleComparison from '../../IncompatibleComparison';
import { CardSkeleton } from '../../Skeleton';
import MetricMatrixContext from '../../../contexts/MetricMatrixContext';

const RankingMatrixView = ({
  isCompatibleComparison,
  isLoading,
  gridOptions,
  colDefs,
  totals,
  visId,
  onDrillDown,
  onGridReady,
  disableAutoLayout,
}: {
  isCompatibleComparison: boolean | undefined;
  isLoading: boolean;
  gridOptions: GridOptions | undefined;
  colDefs: ColDef[];
  totals: any;
  visId: string;
  onDrillDown: (term: string, ctrlKey?: boolean) => void;
  onGridReady: (event: GridReadyEvent) => void;
  disableAutoLayout: boolean;
}) => {
  if (!isCompatibleComparison) {
    return <IncompatibleComparison />;
  }

  if (isLoading || !gridOptions) {
    return <CardSkeleton />;
  }

  return (
    <MetricMatrixContext.Provider value={{ onDrillDown }}>
      <Grid
        columnDefs={colDefs}
        onGridReady={onGridReady}
        gridOptions={gridOptions}
        totalsRow={totals ? totals : undefined}
        gridId={visId}
        disableAutoLayout={disableAutoLayout}
        layoutOnFirstRender={true}
        layoutOnColumnChange={true}
        layoutOnModelUpdated={true}
        hasBorders={false}
        hasDarkHeader={false}
        enableHeadlessRefit
      />
    </MetricMatrixContext.Provider>
  );
};

export default RankingMatrixView;
